import { render, staticRenderFns } from "./ForceAppInstallationStub.vue?vue&type=template&id=92053c9a&scoped=true&"
import script from "./ForceAppInstallationStub.vue?vue&type=script&lang=js&"
export * from "./ForceAppInstallationStub.vue?vue&type=script&lang=js&"
import style0 from "./ForceAppInstallationStub.vue?vue&type=style&index=0&id=92053c9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92053c9a",
  null
  
)

export default component.exports